import React from "react";

export const APPROVED = "approved";
export const DENIED = "denied";

function Approved() {
  return (
    <span className="text-success">
      <i className="fa fa-check" />
      &nbsp;Approved
    </span>
  );
}

function Denied() {
  return (
    <span className="text-danger">
      <i className="fa fa-close" />
      &nbsp;Denied
    </span>
  );
}

const STATUS_COMPONENTS = {
  [APPROVED]: Approved,
  [DENIED]: Denied
};

export default function ApprovalLabel({ status }) {
  return status ? STATUS_COMPONENTS[status]() : null;
}



// WEBPACK FOOTER //
// ./app/modules/shared/components/ApprovalLabel/ApprovalLabel.jsx